<template lang="html">

	<div class="popup-info">

		<a @click="show = !show">

			<svg width="20px" height="20px" viewBox="0 0 24 24">
				<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="04a-mi-cv" transform="translate(-927.000000, -2855.000000)">
						<g id="documentación" transform="translate(42.000000, 2610.000000)">
							<g id="info" transform="translate(886.000000, 246.000000)">
								<circle id="Oval-4" :stroke="colors.basic" stroke-width="1.8" fill-rule="nonzero"
									cx="11" cy="11" r="11"></circle>
								<path d="M11,5 L11,14" id="Stroke-3" :stroke="colors.basic" stroke-width="1.8"
									stroke-linejoin="round"></path>
								<path
									d="M12,16 C12,16.552 11.5526667,17 11,17 C10.448,17 10,16.552 10,16 C10,15.448 10.448,15 11,15 C11.5526667,15 12,15.448 12,16"
									id="Fill-5" :fill="colors.basic"></path>
							</g>
						</g>
					</g>
				</g>
			</svg>

		</a>


		<div class="info-popup" v-show="show" @mouseleave="show = false" :side="side">

			<a @click="show = false" class="cerrar">✕</a>

			<h3 class="title-dato" v-if="!!textos([texto])[lang].titulo">{{textos([texto])[lang].titulo}}</h3>

			<p v-html="textos([texto])[lang].texto"></p>

		</div>
	</div>

</template>

<script lang="js">

	import { mapGetters } from 'vuex';

	export default {
		name: 'popup-info',
		props: ['texto', 'side'],
		data() {
			return {
				show: false
			}
		},
		computed: {
			...mapGetters({
				colors: 'basicColors',
				textos: 'getInfoPopup',
				lang : 'getLanguage'
			}),
		}
	}
</script>

<style scoped lang="scss">
	@import '@/assets/css/colors.scss';

	a {
		border: none;
		outline: none;
		background: transparent;
		cursor: pointer;
	}

	a svg {
		display: block;
	}

	.info-popup {
		position: absolute;
		left: -20px;
		top: -10px;
		background: $dark-black;
		padding: 20px;
		min-width: 320px;
		width: 480px;
		transform: translateX(-100%);
		border-radius: 8px;
		z-index: 10;
	}

	.info-popup[side=right] {
		left: auto;
		right: -25px;
		transform: translateX(100%);
	}

	.cerrar {
		position: absolute;
		right: 10px;
		top: 5px;
		color: white;
		font-size: 10px;
	}

	.info-popup::before {
		content: '';
		position: absolute;
		right: -20px;
		top: 15px;
		border: 10px solid transparent;
		border-left-color: inherit;
	}

	.info-popup[side=right]::before {
		right: auto;
		left: -20px;
		border-left-color: transparent;
		border-right-color: currentColor;
	}

	.info-popup p {
		margin-bottom: 0;
		color: white;
	}

	.title-dato {
		font-size: 20px;
		color: white;
	}

	[dark=true] {
		.info-popup {
			background: $almost-black;
		}

		.info-popup::before {
			border-left-color: $almost-black;
		}

		.info-popup[side=right]::before {
			border-right-color: $almost-black;
			border-left-color:transparent;
		}
	}

	@media screen and (max-width: 1300px) {
		.info-popup[side=right] {
			right: 0;
			top: 50px;
			transform: translateX(50%);

			&::before {
				left: calc(50% - 20px);
				border-right-color: transparent;
				border-bottom-color: currentColor;
				top: -20px;
			}
		}

		.ficha-oferta-alumno .info-popup[side=right] {
			right: 0;
			left: auto;
			top: -10px;
			transform: translateX(105%);

			&::before {
				left: -20px;
				border-right-color: currentColor;
				border-bottom-color: transparent;
				top: 10px;
			}
		}
	}

	@media screen and (max-width: 840px) {

		.-popup-container .popup-info {
			position: static;
		}

		.info-popup {
			position: fixed;
			left: 15px;
			top: 50%;
			transform: none;
			width: calc(100vw - 30px);
			box-shadow: 3px 3px 11px -3px rgba(0, 0, 0, 0.45);
			z-index: 3;
			transform: translateY(-50%);
			max-height: 65vh;
    		overflow-y: scroll;
			z-index: 99;
			&::before {
				display: none;
			}

		}

		.cerrar {
			font-size: 20px;
		}

		.info-popup[side=right] {
			top: 50%;
			right: auto;
			left: 15px;
			transform: translateX(0);
			transform: translateY(-50%);
		}

		.ficha-oferta-alumno .info-popup[side=right] {
			top: 50%;
			transform: translate(0, -50%);
			right: auto;
		}


	}

	@media screen and (max-width: 400px) {
		.info-popup {
			min-width: 200px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-info.vue